import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: { msgKey: '' },
    notificationDialog: {
        open: false,
        receiver: null,
    },
};

const appNotificationSlice = createSlice({
    name: 'appNotification',
    initialState,
    reducers: {
        notificationCreated(state, action) {
            state.value = { msgKey: action.payload };
        },
        notificationDeleted(state, _) {
            state.value = { msgKey: '' };
        },
        notificationDialogOpen(state, action) {
            state.notificationDialog = { open: true, receiver: action.payload };
        },
        notificationDialogClosed(state, action) {
            state.notificationDialog = { open: false, receiver: null };
        },
    },
});

export const {
    notificationCreated,
    notificationDeleted,
    notificationDialogOpen,
    notificationDialogClosed,
} = appNotificationSlice.actions;

export const selectors = {
    getNotification: state => state.appNotification.value,
    getNotificationDialogStatus: state => state.appNotification.notificationDialog,
};

export default appNotificationSlice.reducer;
